import './index.external.css';

var styles = {"backdrop":"backdrop-31Es9","drawerContainer":"drawerContainer-31Es9","bottom":"bottom-31Es9","top":"top-31Es9","left":"left-31Es9","right":"right-31Es9","closeButton":"closeButton-31Es9"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
